export default "__VITE_ASSET__Dyoxi69M__"